import React, { useEffect, useState } from 'react';
import { Form, Input, Message } from '@b-design/fusion';
import $i18n from '@/i18n';
import { Field } from '@alifd/next';
import Uploader from '@/components/Uploader';
import { FormSubmit, promisifyValidate } from '@/components/Button';
import { history } from 'ice';
import Requests from '@/services/request';
import { getQueryStringArgs } from '@/utils/url-parse';

import './index.less';

const StepA: React.FC = () => {
  const field = Field.useField();
  const { init, getValue, setValue, getError } = field;
  const [dataSource, setData] = useState<Record<string, any>>();

  const [refusal, setRefusal] = useState(false);
  const [withdraw, setWithdraw] = useState(false);
  const { invitationCode, companyId, approveId, spaceId = '' } = getQueryStringArgs();
  const [spaceStatus, setSpaceStatus] = useState();
  const [icon, setIcon] = useState<any>({ publicUrl: '', relativePath: '' });

  useEffect(() => {
    if (spaceId) {
      Requests.get('/rest/intercnn/space/query', { spaceIds: spaceId }).then((res) => {
        if (res) {
          const data = { ...res?.list[0], roleList: res?.list[0]?.role?.split(',') || [] };
          setData(data);
          setSpaceStatus(data?.status);
          setRefusal(data?.status === 'REJECT');
          setWithdraw(data?.status === 'WITHDRAW');
          setValue('spaceName', data.name);
          // setValue('logo', [{ publicUrl: data?.iconPublicUrl, relativePath: data?.icon }]);
          setIcon({
            publicUrl: data?.iconPublicUrl,
            relativePath: data?.icon,
          });
        }
      });
    }
  }, [spaceId]);

  // todo: 提交表单
  const submitForm = async () => {
    if (
      spaceStatus !== 'CREATED' &&
      spaceStatus !== 'REJECT' &&
      spaceStatus !== 'WITHDRAW' &&
      spaceId
    ) {
      if (companyId) {
        history?.push(
          `/settlein?invitationCode=${invitationCode}&spaceId=${spaceId}&companyId=${companyId}&approveId=${approveId}&step=1`,
        );
      } else {
        history?.push(`/settlein?invitationCode=${invitationCode}&spaceId=${spaceId}&step=1`);
      }
    } else {
      const [errs, val] = await promisifyValidate(field);
      if (errs) return;
      let params = {};
      let updateParams = {};
      if (val?.logo && val?.logo.length !== 0) {
        params = {
          invitationCode,
          name: val?.spaceName,
          icon: val?.logo[0]?.relativePath,
        };
        updateParams = {
          name: getValue('spaceName'),
          icon: val?.logo[0]?.relativePath,
          spaceId,
        };
      } else {
        params = {
          invitationCode,
          name: val?.spaceName,
          icon: '',
        };
        updateParams = {
          name: getValue('spaceName'),
          spaceId,
          icon: '',
        };
      }
      if (
        spaceId &&
        (spaceStatus === 'CREATED' || spaceStatus === 'REJECT' || spaceStatus === 'WITHDRAW')
      ) {
        const res = await Requests.post('/rest/intercnn/space/update', { ...updateParams });
        if (res) {
          if (companyId) {
            history?.push(
              `/settlein?invitationCode=${invitationCode}&spaceId=${spaceId}&companyId=${companyId}&approveId=${approveId}&step=1`,
            );
          } else {
            history?.push(
              `/settlein?invitationCode=${invitationCode}&spaceId=${spaceId}&step=1`,
            );
          }
        }
      } else {
        const res = await Requests.post('/rest/intercnn/space/create', { ...params });
        if (res) {
          history?.push(
            `/settlein?invitationCode=${invitationCode}&spaceId=${res?.spaceId}&step=1`,
          );
        }
      }
    }
  };

  return (
    <div className="spaceA-container">
      <div className="spaceA-content">
        {refusal == true ? (
          <div className="spaceA-mess">
            <div className="spaceA-mess-pre">
              {$i18n.get({
                id: 'aopf.pages.miniapp.settleIn.Refusal.Reasons',
                dm: '拒绝的申请',
              })}
            </div>
            <div className="spaceA-mess-next">
              {$i18n.get({
                id: 'aopf.pages.miniapp.settleIn.Reasons.rejection',
                dm: '拒绝原因：以下是拒绝的原因',
              })}
              {dataSource?.approveOpinion}
            </div>
          </div>
        ) : null}
        {withdraw == true ? (
          <div className="spaceA-mess2">
            <div className="spaceA-mess2-pre">
              {$i18n.get({
                id: 'aopf.pages.miniapp.settleIn.Withdraw.Application',
                dm: '撤回申请',
              })}
            </div>
            <div className="spaceA-mess2-next">
              {$i18n.get({
                id: 'aopf.pages.miniapp.settleIn.Withdraw.Application.dec',
                dm: '您已撤回申请，您可以编辑并确认信息，然后重新提交',
              })}
            </div>
          </div>
        ) : null}
        <div className="spaceA-title">
          {$i18n.get({ id: 'aopf.pages.space.title', dm: '空间入驻' })}
        </div>
        <div className="spaceA-describe">
          {$i18n.get({
            id: 'aopf.pages.space.spaceRegistration.describe',
            dm: '空间是一个独立的工作空间，您可以在其中开发和管理小型应用程序。在空间中，您还可以邀请开发人员一起工作。',
          })}
        </div>
        <div className="spaceA-form">
          <Form>
            <Form.Item
              name="spaceName"
              label={$i18n.get({
                id: 'aopf.pages.miniapp.settleIn.Space.Name',
                dm: '空间名称',
              })}
              required
              disabled={
                spaceStatus !== 'CREATED' &&
                spaceStatus !== 'REJECT' &&
                spaceStatus !== 'WITHDRAW' &&
                spaceId
              }
            >
              <Input
                placeholder={$i18n.get({
                  id: 'aopf.pages.miniapp.settleIn.Space.Name.characters',
                  dm: '请输入不超过30个字符的空间名称',
                })}
                style={{ width: '640px' }}
                {...init('spaceName', {
                  initValue: '',
                  rules: [
                    {
                      maxLength: 30,
                      required: true,
                      message: $i18n.get({
                        id: 'aopf.pages.miniapp.settleIn.Space.Name.characters',
                        dm: '请输入不超过30个字符的空间名称',
                      }),
                    },
                  ],
                })}
              />
              <p style={{ fontSize: 12, color: '#c82727' }}>{getError('spaceName')}</p>
            </Form.Item>
            <Form.Item
              name="spaceIcon"
              className="icon"
              label={$i18n.get({
                id: 'aopf.pages.miniapp.settleIn.Space.icon',
                dm: '空间图标',
              })}
            >
              <Uploader.Image
                action="/rest/intercnn/space/uploadIcon"
                accept={['image/png', 'image/jpg', 'image/jpeg']}
                disabled={
                  spaceId &&
                  spaceStatus !== 'CREATED' &&
                  spaceStatus !== 'REJECT' &&
                  spaceStatus !== 'WITHDRAW'
                }
                maxSize={1024 * 1024}
                key={icon?.relativePath}
                {...init('logo', {})}
                value={
                  icon?.relativePath
                    ? [
                      {
                        uid: '0',
                        state: 'done',
                        url: icon?.publicUrl,
                        downloadURL: icon?.publicUrl,
                        imgURL: icon?.publicUrl,
                        relativePath: icon?.relativePath,
                        publicUrl: icon?.publicUrl,
                      },
                    ]
                    : []
                }
                onCheckFail={(err, response, e) => {
                  Message.warning({ title: response.msg });
                }}
                onError={() => {
                  Message.error({
                    title: $i18n.get({
                      id: 'aopf.pages.miniapp.drawer.form.icon.Upload.failure',
                      dm: '上传失败',
                    }),
                  });
                }}
                settlein={true}
              />
              <div className="upload">
                {$i18n.get({
                  id: 'aopf.pages.miniapp.drawer.form.upload.img.format1',
                  dm: '文件类型:',
                })}
                <span>
                  {$i18n.get({
                    id: 'aopf.pages.miniapp.drawer.form.upload.img.format1.content',
                    dm: '.png / .jpg / .jpeg',
                  })}
                </span>
                <br />
                {$i18n.get({
                  id: 'aopf.pages.miniapp.drawer.form.upload.img.format2',
                  dm: '规格:',
                })}
                <span>
                  {$i18n.get({
                    id: 'aopf.pages.miniapp.drawer.form.upload.img.format2.content',
                    dm: '180px * 180px',
                  })}
                </span>
                <br />
                {$i18n.get({
                  id: 'aopf.pages.miniapp.drawer.form.upload.img.format3',
                  dm: '最大大小:',
                })}
                <span>
                  {$i18n.get({
                    id: 'aopf.pages.miniapp.drawer.form.upload.img.format3.content',
                    dm: '1M',
                  })}
                </span>
                <br />
                {$i18n.get({
                  id: 'aopf.pages.miniapp.drawer.form.upload.img.format4',
                  dm: '背景:',
                })}
                <span>
                  {$i18n.get({
                    id: 'aopf.pages.miniapp.drawer.form.upload.img.format4.content',
                    dm: '不透明',
                  })}
                </span>
              </div>
            </Form.Item>
            <Form.Item name="Next Step">
              <FormSubmit
                type="primary"
                onClick={submitForm}
                validate
                style={{
                  height: 40,
                  borderRadius: 4,
                  fontWeight: 500,
                  fontSize: 16,
                  color: '#fff',
                  letterSpacing: '0.15px',
                  marginTop: 310,
                  marginRight: 0,
                  float: 'right',
                }}
              >
                {$i18n.get({
                  id: 'aopf.pages.miniapp.settleIn.Next.Step',
                  dm: '下一步',
                })}
              </FormSubmit>
            </Form.Item>
          </Form>
        </div>
      </div>
    </div>
  );
};

export default StepA;
